module.exports = __webpack_public_path__ + "static/media/logo.9db7b866.png";